import { schema } from "normalizr";

export const hotelRoomSchema = new schema.Entity("hotelRooms");
export const hotelPlanSchema = new schema.Entity("hotelPlans");
export const hotelRoomPlanSchema = new schema.Entity("hotelRoomPlans");
export const hotelSchema = new schema.Entity(
  "hotel",
  {
    hotelPlans: [hotelPlanSchema],
    hotelRooms: [hotelRoomSchema],
    hotelRoomPlans: [hotelRoomPlanSchema],
  },
  { idAttribute: "code" },
);
